import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import { Redirect } from 'react-router-dom';

import SaldosMovimientos from './SaldosMovimientos/SaldosMovimientos';
import DatosGeneralesCuenta from './DatosGeneralesCuenta/DatosGeneralesCuenta';
import ModalHistorialModificaciones from '../HistorialModificacionCuenta/ModalHistorialModificaciones';
import IntegrantesCuenta from './Integrantes/IntegrantesCuenta';
import HistorialTarjetas from './Integrantes/HistorialTarjetas'; 
import BajaCuentaPrepaga from './BajaCuentaPrepaga/BajaCuentaPrepaga';
import AutorizacionesRechazadas from './AutorizacionesRechazadas/AutorizacionesRechazadas'
import Header from './Header';
import MenuDesplegable from './MenuDesplegable'; 
import IngresoAjustes from './IngresoAjustes/IngresoAjustes';
import ModalDatosCuenta from './ModalDatosCuenta'

class DatosCuenta extends PureComponent {
    constructor(props) {
        super(props);
        //Funciones Saldos y Movimientos
        this.actualizarSaldosParaMostrar = this.actualizarSaldosParaMostrar.bind(this);
        this.buscarMovimientos = this.buscarMovimientos.bind(this);
        this.limpiarMovimientos = this.limpiarMovimientos.bind(this);
        this.ocultarModal = this.ocultarModal.bind(this);      
        this.mostrarCalendario = this.mostrarCalendario.bind(this);
    }
    
    mostrarCalendario(){
        this.props.actions.mostrarCalendario();
    }

    limpiarMovimientos(){
        this.props.actions.limpiarMovimientos();
    }

    ocultarModal(){
        this.props.actions.ocultarModal();
    }

    buscarMovimientos(fechaDesde,fechaHasta){
        this.props.actions.buscarMovimientos(fechaDesde,fechaHasta);
    }

    validarFormatoFechaHasta(fecha){
        this.props.actions.validarFormatoFechaHasta(fecha);
    }

    validarFormatoFechaDesde(fecha){
        this.props.actions.validarFormatoFechaDesde(fecha);
    }

    actualizarSaldosParaMostrar() {
        this.props.actions.actualizarSaldosParaMostrar();
    }

    componentDidMount() {
        //let idCuenta = this.props.vistaCliente.idEntidad;
        this.props.actions.resetState();
        this.props.actions.GetScreenData(this.props.currentScope,this.props.executionContext);
    }
    componentWillUnmount() {
        this.props.actions.resetState(); 
        this.props.actions.resetPropTarjetas("darDeBajaCuenta");
    }

    render() {
        const { data, tarjetas, ingresoAjustes } = this.props;

         /*PERMISOS*/
         const permisos = tarjetas.claims ? tarjetas.claims.CONSULTASOCIOS : [];
         const permisosIntegrantes = data && data.integrantesFuncionesUsuario ? data.integrantesFuncionesUsuario : []; /* tarjetas.claims ? tarjetas.claims.ADMINEMPCUETAR : []; */
         const permisoModificacion = data && data.funcionesDelUsuario ? data.funcionesDelUsuario.Modificacion : [];// ? data.funcionesDelUsuario.some(p=>p.Codigo_Funcion == "Modificacion") : [];
         const permisoConfirmacion = data && data.funcionesDelUsuario ? data.funcionesDelUsuario.Confirmacion : [];// ? data.funcionesDelUsuario.some(p=>p.Codigo_Funcion == "Confirmacion") : [];
         const permisoBaja = true;//permisos.some(p=>p.Codigo_Funcion == "Baja");
         const permisoIngresoAjustes = data && data.ingresoAjustesFuncionesUsuario; //Se agrega validación de permisos para Ajustes/Cargos Individuales. #ADT-1983
         /*FIN PERMISOS*/
         
        //const {selectCombo} = this.props.actions;
        let { isLoading } = false//data; 
        let componente = <div className="loading">Loading &#8230;</div>;
        let componenteActual = tarjetas.componenteVistaCliente != null ? tarjetas.componenteVistaCliente : data.componenteActual;
        if (data.redirect.shouldRedirect) {
            return <Redirect to={data.redirect.to} push />;
            //return <Redirect to={ProcessManager.GetNextStep("DatosCuenta", "ROUTE_TO_VISTA_CLIENTE")} push />
        }
        let seccionActual = null;

        switch (componenteActual){
            case 1:{
                seccionActual= <SaldosMovimientos data={data} form={this.props.form} cambiarMesPorFlecha={this.props.actions.cambiarMesPorFlecha} mostrarCalendario={this.mostrarCalendario} limpiarMovimientos={this.limpiarMovimientos} ocultarModal={this.ocultarModal} ocultarModalAdvertencia={this.props.actions.ocultarModalAdvertencia} actualizarSaldosParaMostrar={this.actualizarSaldosParaMostrar} validarFormatoFecha={this.props.actions.validarFormatoFecha}  selectRadio={this.props.actions.selectRadio} buscarMovimientos={this.buscarMovimientos}/>
                break;
            }
            case 2: {
                seccionActual = <DatosGeneralesCuenta permisoModificacion={permisoModificacion} permisoConfirmacion={permisoConfirmacion} openModal={this.props.actions.openModal} data={this.props.data} actions={this.props.actions} form={this.props.form} />
                break;
            } 
            case 3: {
                seccionActual = <IntegrantesCuenta permisosIntegrantes={permisosIntegrantes} permisoModificacion={permisoModificacion} cuentaId={tarjetas.cuentaCorriente.CuentaTarjetaId} data={this.props.data} actions={this.props.actions} abrirPopUp={this.props.actions.abrirPopUp} obtenerHisotrialTarjetas={this.props.actions.obtenerHisotrialTarjetas} />
                break;
            } 
            case 4: {
                seccionActual = <BajaCuentaPrepaga permisoBaja={permisoBaja} permisoModificacion={permisoModificacion} permisoConfirmacion={permisoConfirmacion} actions={this.props.actions} tarjetas={tarjetas} data={data}/>
                break;
            }
            case 5: {
                seccionActual = <AutorizacionesRechazadas data={data} actions={this.props.actions} cuentaId={tarjetas.cuentaCorriente.CuentaTarjetaId} />
                break;
            }
            case 6: {
                seccionActual = <IngresoAjustes data={data} cuenta={tarjetas.cuentaCorriente} actions={this.props.actions} cuentaId={tarjetas.cuentaCorriente.CuentaTarjetaId} ingresoAjustes={ingresoAjustes} />
                break;
            }
        } 

        let modalPermisoIngresoAjuste = data && data.modalPermisoIngresoAjustes ? <ModalDatosCuenta
                                                                ocultarModal={this.props.actions.ocultarModalDatosCuentaIngresoAjustes}
                                                                titulo="Ajustes y Cargos Individuales"
                                                                mensaje={"Disculpe, no tiene permisos para acceder a esta pantalla."}
                                                                />
                                                            :
                                                                null;

        if (!isLoading) {
            componente = <div className="container">
                {data.modalHistorialModificaciones && data.datosHistorialModificaciones && <ModalHistorialModificaciones listaModificaciones={data.datosHistorialModificaciones} openModal={this.props.actions.openModal}/>}
                <Header datosActualizados={data.SaldosMovimientos.datosActualizados} parametros={data.parametroGeneral} cliente={tarjetas.Cliente} administradora={tarjetas.cuentaCorriente.marcaId} cuenta={tarjetas.cuentaCorriente} />
                <div className="container-fluid row">
                    <div className="col-xs-3">
                        <MenuDesplegable permisoBaja={permisoBaja} cuentaEstadoId={tarjetas.cuentaCorriente.cuentaTarjetaEstadoId} componenteActual={componenteActual} seleccionarComponente={this.props.actions.seleccionarComponente} redirectToVistaCliente={this.props.actions.redirectToVistaCliente} openPanelDatosCuenta={this.props.actions.openPanelDatosCuenta} permisoIngresoAjustes={permisoIngresoAjustes} openModal={this.props.actions.openModal} />
                    </div>
                    <div className="contenedorSeccionesCuenta col-xs-9 left-separator no-padding-right">
                         {modalPermisoIngresoAjuste}
                         {seccionActual}   
                    </div>
                </div>
            </div>
        }
        return componente;
    }
}
export default createForm()(DatosCuenta);